module.exports = __webpack_public_path__ + "static/media/Send_to_Bank.3c3bb7cc.svg";